import React from 'react';
import './../../../styles/modal.css';
import classNames from 'classnames';

const Modal = ({ open = false , ...props}) => {
    return (
        <div className={classNames('main-modal', { isGray: open === true, noGray: open === false, withoutZindex: open === false })}>
            <div className={classNames('modal-body row', { show: open === true, hidden: open === false })}>
                {props.children}
            </div>
        </div>
    )
}

export default Modal;



// WEBPACK FOOTER //
// ./src/components/shared/modal/index.js